// We need to set the publicpath as early as possible otherwise it won't work.
// Import this module above any components that rely on it.

declare var __webpack_public_path__: string;

if (__ENV_PROD__) {
  // https://webpack.js.org/guides/public-path/#on-the-fly
  __webpack_public_path__ = window.__cdn_url__ + '/';
}
